import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import Pagination10 from './components/Pagination10';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ConfirmModal from './components/modals/ConfirmModal';
import usePagination10 from './components/hooks/usePagination10';
import VinculoModal from './components/modalServices/VinculoModal';
import ManageAccessModal from './components/modals/ManageAccessModal';
import PageCard from './components/PageCard';

function UsuariosVinculos() {
  const [Usuario, setUsuario] = useState({
    cpf: '',
    nome: '',
    login: '',
    senha: '',
    situacao: '',
    role: '',
  });
  const [UsuariosBind, setUsuariosBind] = useState([]);
  const [atualizar, setAtualizar] = useState(false);
  const [showUsuarioVinculoModal, setShowUsuarioVinculoModal] = useState(false);
  const [vinculoParaEditar, setVinculoParaEditar] = useState(null);
  const [vinculoSelecionado, setVinculoSelecionado] = useState(null);
  const [showManageAccessModal, setShowManageAccessModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [Associacaos, setAssociacaos] = useState([]);
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const totalItems = UsuariosBind.length;
  const { setPagination } = usePagination10(totalItems);
  const displayedUsuarios = UsuariosBind.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  useEffect(() => {
    if (location.state && location.state.usuario) {
      console.log('Usuário recebido do estado:', location.state.usuario);
      setUsuario(location.state.usuario);
    }
  }, [location.state]);

  // Carregar associações para preencher o modal
  useEffect(() => {
    axios
      .get(`${API_BASE_URL.ASSOCIACAO}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {

        setAssociacaos(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter associações:', error);
      });
  }, [token]);

  useEffect(() => {
    if (Usuario.cpf !== '') {
      axios
        .get(`${API_BASE_URL.REL_ASSOCIACAO_USUARIO}/cpf`, {
          params: { cpf: Usuario.cpf },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          setUsuariosBind(result.data);
          setVinculoSelecionado(null); // Limpar seleção quando dados mudarem
        })
        .catch(error => {
          console.error('Erro ao obter registros:', error);
        });
    }
  }, [Usuario.cpf, token, atualizar]);

  function handleDelete(usuarioToDelete) {
    showConfirmModal('delete', () => handleConfirmDelete(usuarioToDelete));
  }

  function handleConfirmDelete(usuarioToDelete) {
    axios
      .delete(
        `${API_BASE_URL.REL_ASSOCIACAO_USUARIO}/delete/${usuarioToDelete.cpf}/${usuarioToDelete.cnpj}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setAtualizar(!atualizar);
        showDefaultModal('success', 'O registro foi excluído com sucesso!');
      })
      .catch(error => {
        console.error('Erro ao deletar:', error);
        showDefaultModal('error', 'Erro ao excluir o registro');
      });
  }

  function handleNovoVinculo() {
    setVinculoParaEditar(null);
    setShowUsuarioVinculoModal(true);
  }

  function handleEditarVinculo() {
    if (vinculoSelecionado) {

      setVinculoParaEditar(vinculoSelecionado);
      setShowUsuarioVinculoModal(true);
    }
  }

  function handleVinculoSaveSuccess(dadosVinculo) {
    axios
      .post(`${API_BASE_URL.REL_ASSOCIACAO_USUARIO}/save`, dadosVinculo, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        setAtualizar(!atualizar);
        setShowUsuarioVinculoModal(false);
        setVinculoSelecionado(null); // Limpar seleção após salvar
        showDefaultModal('success', 'Vínculo salvo com sucesso!');
      })
      .catch(error => {
        console.error('Erro ao salvar vínculo:', error);
        showDefaultModal('error', 'Erro ao salvar o vínculo');
      });
  }

  function handlePermissoesSaveSuccess() {
    showDefaultModal('success', 'Permissões salvas com sucesso!');
  }

  return (
    <PageCard
      title="Vinculação de Usuários"
      icon="bi-link-45deg"
      scrollable={false}
      onClose={() => navigate('/usuarios')}
      footer={totalItems > 0 ? <Pagination10 {...setPagination} /> : null}
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>

        <div className="d-flex flex-wrap gap-1 mb-2 p-2 bg-light rounded border align-items-center">
          <button
            className="btn btn-success btn-sm d-inline-flex align-items-center"
            onClick={handleNovoVinculo}
          >
            <i className="bi bi-plus-lg me-1" />
            Novo Vínculo
          </button>
          <button
            className="btn btn-warning btn-sm d-inline-flex align-items-center"
            onClick={handleEditarVinculo}
            disabled={!vinculoSelecionado}
          >
            <i className="bi bi-pencil me-1" />
            Editar
          </button>
          <button
            className="btn btn-info btn-sm d-inline-flex align-items-center"
            onClick={() => {
              if (vinculoSelecionado) {
                setShowManageAccessModal(true);
              }
            }}
            disabled={!vinculoSelecionado}
          >
            <i className="bi bi-shield-lock me-1" />
            Permissões
          </button>
          <div className="vr mx-1" />
          <button
            className="btn btn-danger btn-sm d-inline-flex align-items-center"
            onClick={() => vinculoSelecionado && handleDelete(vinculoSelecionado)}
            disabled={!vinculoSelecionado}
          >
            <i className="bi bi-trash me-1" />
            Excluir
          </button>
        </div>

        <div
          className="table-responsive-sm shadow-sm mb-0 small"
          style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}
        >
              <table className="table table-hover table-striped table-sm small">
                <thead className="table-secondary sticky-top bg-light">
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">Cidade</th>
                    <th scope="col">UF</th>
                    <th scope="col">Tipo de Vínculo</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedUsuarios.map(usu => (
                    <tr
                      key={`${usu.cnpj}-${usu.cpf}`}
                      className={`${
                        vinculoSelecionado?.cnpj === usu.cnpj &&
                        vinculoSelecionado?.cpf === usu.cpf
                          ? 'table-success'
                          : ''
                      }`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (
                          vinculoSelecionado?.cnpj === usu.cnpj &&
                          vinculoSelecionado?.cpf === usu.cpf
                        ) {
                          setVinculoSelecionado(null); // Deselecionar se já estiver selecionado
                        } else {
                          setVinculoSelecionado(usu); // Selecionar novo vínculo
                        }
                      }}
                    >
                      <td>{usu.associacao.nome}</td>
                      <td>{usu.associacao.logrCidade}</td>
                      <td>{usu.associacao.logrUf}</td>
                      <td>{usu.tipo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Mensagem quando não há vínculos */}
              {displayedUsuarios.length === 0 && (
                <div className="text-center p-4">
                  <div className="text-muted">
                    <i className="bi bi-info-circle me-2"></i>
                    Nenhum vínculo encontrado para este usuário.
                  </div>
                </div>
              )}
            </div>
      <ConfirmModal {...setConfirmModal} />
      <DefaultModal {...setDefaultModal} />
      <VinculoModal
        show={showUsuarioVinculoModal}
        onClose={() => setShowUsuarioVinculoModal(false)}
        onSaveSuccess={handleVinculoSaveSuccess}
        vinculo={vinculoParaEditar}
        associacaos={Associacaos}
        usuario={Usuario}
      />
      <ManageAccessModal
        show={showManageAccessModal}
        onClose={() => setShowManageAccessModal(false)}
        onSaveSuccess={handlePermissoesSaveSuccess}
        cpf={Usuario?.cpf}
        userName={Usuario?.nome}
        currentCnpj={vinculoSelecionado?.cnpj}
        associacaoName={vinculoSelecionado?.associacao?.nome}
      />
    </div>
  </PageCard>
  );
}

export default UsuariosVinculos;
